import PurchaseModal from 'components/Fate/components/PurchaseModal/PurchaseModalContainer';
import { REFILL_OPPORTUNITY_DECK } from 'constants/fateActions';
import React from 'react';
import { connect } from 'react-redux';
import { IAppState } from 'types/app';

type Props = ReturnType<typeof mapStateToProps> & {
  isOpen: boolean,
  onRequestClose: () => void,
};

export function RefillOpportunityDeckModal({ fateData, isOpen, onRequestClose }: Props) {
  const data = fateData.fateCards.find(({ action }: { action: string }) => action === REFILL_OPPORTUNITY_DECK);

  if (!data) {
    return null;
  }

  return (
    <PurchaseModal
      data={data}
      isOpen={isOpen}
      onRequestClose={onRequestClose}
    />
  );
}

const mapStateToProps = (state: IAppState) => ({
  fateData: state.fate.data,
});

export default connect(mapStateToProps)(RefillOpportunityDeckModal);
